interface PostAuthorSignatureProps {
  signature: string | null
}

const PostAuthorSignature = ({ signature }: PostAuthorSignatureProps) => {
  return (
    <div className='post---author-signature'>
      <hr />
      <p className='text-muted'>{signature}</p>
    </div>
  )
}

export default PostAuthorSignature
